module.exports = __webpack_public_path__ + "static/cukolada-gdpr-5a072b8769f1fab50ff85ce0aef6966c.pdf";